/*
Gets selected group by options
*/

const getSelectedGroupByOptions = (groupBy, isComparingDates = false) => {
    if (!groupBy) return [];

    let options = Object.entries(groupBy).reduce((acc, [key, isSelected]) => {
        if (isSelected) acc.push(key);
        return acc;
    }, []);

    if (isComparingDates && options.length === 0) {
        return ['date'];
    }

    if (isComparingDates && options.length > 0) {
        return options.filter(o => o !== 'date');
    }

    return options;
};

export default getSelectedGroupByOptions;
